<!-- Mission Banner -->
<p class="s1 m-t-6 center p-b-7">{{'My Profile' | translate}}</p>
@if ((showBanner && content )) {
<p class="col-11 p2 m-t-1 center">
    {{('Complete your profile and earn' + (mission!.rosettes ? ' % rosettes' : ' % points')) | translate :
    (mission!.rosettes || mission!.points)}}
</p>
<a class="button w-12 m-t-6"
   [routerLink]="'/profile-mission'">
    {{"Start '%' Mission" | translate : mission!.title}}
</a>
} @else {
<!-- Customer Profile -->
<div class="flex-column"
     style="gap: 16px;">
    <ng-container *ngTemplateOutlet="prifileTpl; context: {
        icon: 'icon-profile-outline',
        title: 'My profile',
        nickname: customerNickname,
        editLink: ['/account/profile/customer/edit'],
        imageRole: 'profile'
    }"></ng-container>

    <ng-container *ngTemplateOutlet="prifileTpl; context: {
        icon: 'icon-horse-head-outline',
        title: 'My horse',
        nickname: horses?.[0]?.name,
        editLink: ['/account/profile/horse/edit', 0],
        imageRole: 'horse',
        imageIndex: 0
    }"></ng-container>


    <ng-container *ngTemplateOutlet="prifileTpl; context: {
        icon: 'icon-profile-outline',
        title: 'Family Member',
        nickname: familyMembers?.[0]?.name,
        editLink: ['/account/profile/member/edit', 0],
        imageRole: 'family_member',
        imageIndex: 0
    }"></ng-container>

</div>


<ng-template #prifileTpl
             let-icon="icon"
             let-title="title"
             let-nickname="nickname"
             let-editLink="editLink"
             let-imageRole="imageRole"
             let-imageIndex="imageIndex">
    <div class="bg-col-w p-a-5 p-t-6 p-b-6 flex flex-justify-between"
         [ngClass]="nickname ? 'flex-top' : 'flex-middle'">
        <div class="flex flex-middle">
            <div class="_profile-avatar m-r-2">
                @if (getUserImageUrl(imageRole, imageIndex)) {
                <!-- Display profile image if available -->
                <img [dfImage]="getUserImageUrl(imageRole, imageIndex)"
                     [loaderParams]="{quality: 100, upscale: true}"
                     [width]="24"
                     [height]="24"
                     [ratio]="1"
                     class="_profile-image"
                     [alt]="title + ' image'">
                } @else {
                <!-- Fallback to icon -->
                <i [ngClass]="icon"
                   class="inline-flex"
                   style="font-size: 24px;"></i>
                }
            </div>
            <div class="_profile-content">
                <h4 class="p1">{{title | translate}}</h4>
                @if (nickname) {
                <p class="p2 m-t-1 col-11">{{nickname}}</p>
                }
            </div>
        </div>
        <a [routerLink]="editLink"
           class="button-inline-2 p2">
            <span>{{nickname ? 'Edit' : 'Add' | translate}}</span>
        </a>
    </div>
</ng-template>
}
